import { APPROVAL_TYPES_FETCH_TYPES } from '../action-types/approval-types';

const initialState = {
  entities: [],
  entity: {},
  entityLoaded: false,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case APPROVAL_TYPES_FETCH_TYPES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case APPROVAL_TYPES_FETCH_TYPES.SUCCESS:
      return {
        ...state,
        entities: [...action.payload.data],
        loading: false,
      };
    case APPROVAL_TYPES_FETCH_TYPES.REJECTED:
      return {
        ...state,
        loading: false,
        entities: [],
      };
    default:
      return state;
  }
}
